import React, { useEffect } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import { useDispatch, useSelector } from 'react-redux'
import { fetchClasses } from '../../../../store/actions/classesDivisionsActions'
import { Link } from 'react-router-dom'
import EmptyState from '../../../../components/elements/EmptyState'
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon'

const ClassesDivisions = () => {
  const dispatch = useDispatch()
  const classesSelector = useSelector(state => state.classes)

  useEffect(() => {
      dispatch(fetchClasses())
      return () => {
          
      };
  }, [dispatch]);

  return (
    <AdministrationLayout>
      <div className='w-full'>
        <div className='w-full flex justify-between mb-8'>
          <div className='w-9/12'>
            <h3 className='text-lg font-medium'>Vaatia College Classes</h3>
            <p className='text-sm'>All classes in vaatia college Makurdi. Click on a class to view details, subject and students</p>
          </div>
          
          <div>
            {/* <button onClick={()=>{setCreatingDepartment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
              <PlusIcon className='w-5 h-5' /> Create Department
            </button> */}
          </div>
        </div>

        {classesSelector.classes?.classes?.length > 0 ? <div className='grid grid-cols-3 gap-6'>
          {classesSelector.classes?.classes?.map((singleClass, singleClassIndex)=>(<Link key={singleClassIndex}>
            <div className='w-full p-4 rounded-[8px] flex items-start gap-x-3 border bg-white border-transparent hover:bg-gray-50 transition duration-200 cursor-pointer'>
              <div className='w-full'>
                <p className='text-xl font-medium text-vcm-purple'>{singleClass.name}</p>
                {/* <p className='text-xs text-gray-500'>{document.description}</p> */}
                <div className='flex items-center gap-x-1 mt-1'>
                  <p className='text-sm text-gray-500'>{singleClass.divisions?.length} arms</p>
                  <p className='text-sm text-gray-500'>{singleClass.totalStudents} students</p>
                </div>
                <p className='text-sm text-gray-500 mt-3'>Created {new Date(singleClass.createdAt)?.toLocaleDateString()}</p>

                <div className='flex flex-row-reverse mt-3'>
                  <Link to={singleClass._id} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>
                    View/Edit Class <ArrowIcon className={`w-5 h-5`} /></Link> 
                  </div>
                </div>
            </div>
          </Link>))}
        </div>
        :
        <div className='mt-12 w-1/3 mx-auto'>
          <EmptyState emptyStateText={`No documents created yet. You can create a new document by clicking on the "Create Document" button above`} />
        </div>
        }
      </div>
    </AdministrationLayout>
  )
}

export default ClassesDivisions